import React, { useEffect } from 'react'
import { CheckCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useNetwork } from 'wagmi'

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const ValidatorCreation = styled.p`
  margin: 0;
  margin-top: 46px;
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
`

const TransactionWrapper = styled.p`
  margin: 0;
  margin-top: 25px;
  margin-bottom: 25px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
`

interface ILoading {
  tx: ITransaction
  resetState?: () => void
}
export interface ITransaction {
  to: string
  from: string
  contractAddress: null
  transactionIndex: number
  gasUsed: CumulativeGasUsed
  logsBloom: string
  blockHash: string
  transactionHash: string
  logs: Event[]
  blockNumber: number
  confirmations: number
  cumulativeGasUsed: CumulativeGasUsed
  effectiveGasPrice: CumulativeGasUsed
  status: number
  type: number
  byzantium: boolean
  events: Event[]
}

export interface CumulativeGasUsed {
  type: string
  hex: string
}

export interface Event {
  transactionIndex: number
  blockNumber: number
  transactionHash: string
  address: string
  topics: string[]
  data: string
  logIndex: number
  blockHash: string
}

export const ValidatorCreated = ({ tx, resetState }: ILoading) => {
  const history = useHistory()
  const { chain } = useNetwork()

  useEffect(() => {
    const timeout = setTimeout(() => {
      history.push('/validators')
      return () => {
        clearTimeout(timeout)
      }
    }, 15000)
  }, [])
  return (
    <LoadingWrapper>
      <CheckCircleOutlined style={{ fontSize: 80, color: '#52C41A' }} />
      <ValidatorCreation>Validator created successfully</ValidatorCreation>
      {tx?.transactionHash && (
        <TransactionWrapper>
          Transaction:{' '}
          <a
            href={`${chain.blockExplorers.default.url}/tx/${tx.transactionHash}`}
            target="_blank"
            rel="noreferrer"
          >
            {tx.transactionHash}
          </a>
        </TransactionWrapper>
      )}
      <Button type="primary" onClick={resetState}>
        Create new validator
      </Button>
    </LoadingWrapper>
  )
}
